<template>
    <div>
        <Item v-for="scan_action_prototype in scan_action_prototypes"
            :scan_action_prototype="scan_action_prototype"
            :key="scan_action_prototype.identity"
            >
        </Item>
    </div>
</template>

<script>
import Item from './print_item.vue'

export default {
    props: {
        scan_action_prototypes: Array
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        Item
    }
}
</script>
